export default "__VITE_ASSET__C9sg$Tad__"